import React, { useEffect, useRef, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import BotAnalytics from './BotAnalytics';
import { BotAnalyticsData } from '../../api/types';
import EmptyBotList from './EmptyBotList';

type BotAnalyticsCarouselProps = {
  bots: BotAnalyticsData[];
  defaultBotId?: string;
};

const BotAnalyticsCarousel: React.FC<BotAnalyticsCarouselProps> = ({ bots, defaultBotId }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const carouselRef = useRef<Carousel>(null);

  useEffect(() => {
    if (defaultBotId && bots.length) {
      const index = bots.findIndex((bot) => bot.id === defaultBotId);
      if (index !== -1) setSelectedIndex(index);
    }
  }, [defaultBotId, bots]);

  const handlePrev = () => {
    setSelectedIndex((prev) => (prev - 1 + bots.length) % bots.length);
  };

  const handleNext = () => {
    setSelectedIndex((prev) => (prev + 1) % bots.length);
  };

  if (bots.length === 0) {
    return (
      <EmptyBotList></EmptyBotList>
    );
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {/* Arrows at the top */}
      <button
        onClick={handlePrev}
        style={{
          position: 'absolute',
          top: '24px',
          left: '12px',
          zIndex: 2,
          height: '48px',
          width: '48px',
          borderRadius: '12px',
          background: '#fff',
          border: '1px solid #ccc',
          fontSize: '22px',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-label="Previous"
      >
        ‹
      </button>

      <button
        onClick={handleNext}
        style={{
          position: 'absolute',
          top: '24px',
          right: '12px',
          zIndex: 2,
          height: '48px',
          width: '48px',
          borderRadius: '12px',
          background: '#fff',
          border: '1px solid #ccc',
          fontSize: '22px',
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
        aria-label="Next"
      >
        ›
      </button>

      <Carousel
        ref={carouselRef}
        selectedItem={selectedIndex}
        onChange={setSelectedIndex}
        showThumbs={false}
        infiniteLoop={false}
        showStatus={false}
        dynamicHeight={false}
        swipeable
        emulateTouch
        useKeyboardArrows
      >
        {bots.map((bot) => (
          <div
            key={bot.id}
            style={{
              height: '100%',
              width: '100%',
              padding: '16px',
              boxSizing: 'border-box',
              backgroundColor: '#fff',
              borderRadius: '12px',
              overflow: 'hidden',
            }}
          >
            <BotAnalytics
              botName={bot.name}
              enabled={bot.enabled}
              focus={bot.focus}
              type={bot.type}
              activeThreads={bot.activeThreads}
              inactiveThreads={bot.inactiveThreads}
              userMessages={bot.totalUserMessages}
              threads={bot.threadSummaries}
            />
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default BotAnalyticsCarousel;
